import { getIsQa } from '../../constants/apiEnvironments';
import { FlowStateManager } from '../../flow-management/FlowStateManager';
import { getQueryParam } from '../../routing/getQueryParam';
import { Step } from '../../views/Step';
export const BranchConsiderationProfiles = {
  name: 'BranchConsiderationProfiles',
  stateCheck: () => {
    return getQueryParam('consideration-profiles-active') === 'true' && getIsQa();
  },
  rebuildFlow: (flow, state, dispatch) => {
    const nextSteps = dispatch(FlowStateManager.replaceStep(Step.Name, Step.Name, Step.ProductExperience, Step.ProblemAwareness));
    return nextSteps;
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};